import React from 'react';
import {Link} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';
import {getWorkbooks} from '../../../api/workbooks';
import {Page} from '../../layout/Pages';

export default function WorkbookList() {
    const {data: workbooks} = useQuery(['workbooks'], getWorkbooks);

    if (!workbooks) return <></>;

    return (
        <Page title="Workbooks">
            <ul className="divide-y divide-gray-200">
                {workbooks.map(wb => (
                    <li key={wb.id} className="py-2">
                        <Link to={`/workbooks/${wb.id}`} className="text-indigo-600 hover:underline">
                            {wb.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </Page>
    );
}
